import * as actionTypes from "../Actions/DocumentationActionTypes";
import LogService from "../../CommonSdk/LogService";
import * as DocumentationConstant from "../../Constants/DocumentationConstant";

const LOG_TAG = "REDUCER:DOCUMENTATION";

const initialState = {
    filter: DocumentationConstant.DocumentationType.Lts
}

export default function (state = initialState, action) {
    switch (action.type) {
        case actionTypes.SET_FILTER:
            LogService.info(LOG_TAG, "reduce", "" + action.type + " - Set Filter:"+ JSON.stringify(action));
            return {
                ...state,
                filter: action.value,
            };

        case actionTypes.CLEAR_FILTER:
            LogService.info(LOG_TAG, "reduce", "" + action.type);
            return {
                ...initialState
            };           

        default:
            return state;
    }
}
